import { Redirect, Route, Switch } from 'react-router-dom'
import { styled } from '@mui/system'
import { ProjectPlan } from './ProjectPlan'
import { ProjectPlanGantt } from './ProjectPlanGantt'
import { ProjectKanban } from './ProjectKanban'
import { MyTasks } from './MyTasks'
import { BurndownChart } from './BurndownChart'
import { ProjectVersionReport } from './ProjectVersionReport'
import { DemoSideMenu } from './layout/DemoSideMenu'
import { DemoUserInformationHeader } from './layout/DemoUserInformationHeader'
import { useFetchDemoWbsItemTypes } from './useFetchDemoWbsItemTypes'
import { useSeedDemoTenant } from './useSeedDemoTenant'
import { demoProject } from '../data/projects/project'

// 本物のSideMenu/UserInformationHeaderはプロジェクト切替・認証済みユーザー情報等、
// デモ環境には存在しないRedux state・API呼び出しに依存するため使用できない。
// 代わりに見た目の骨格のみを再現したMock版（layout/配下）に差し替えて表示する。
// FLAGXS_DEMO_MODE時はindex.tsxがApp.tsxではなくDemoApp.tsxを描画するため、
// TenantPrivate（テナント切替・契約同意チェック・プロジェクト割当取得等の
// 認証初期化フロー）や/login等の認証系ルートを一切経由しない。
const RootContainer = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
})

// 本物のApp.tsxのContentと同じく、ヘッダーと画面を積み上げるだけの
// 通常フローのブロックにする。flexコンテナにして画面側へ残り高さを
// 配分してはいけない: 各画面のPageArea（view/pages/index.tsx）が
// height: calc(100% - 56px)とヘッダー分を自前で差し引いているため、
// ここでも差し引くと56pxが二重に引かれ、画面下部に隙間ができる。
const DemoContent = styled('main')({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
})

export const DemoRoutes = () => {
  // タイマー機能のfeatureFlagがstate.tenant.organization.aliasを見るため、
  // 各画面の初回レンダーより先にテナントを埋める。
  useSeedDemoTenant()
  // Excelインポート等がstore.getState().project.wbsItemTypes/selectedを
  // 直接参照するため、個別の画面ではなくルート直下で一度だけ取得しstoreへ反映する。
  useFetchDemoWbsItemTypes(demoProject)
  return (
    <RootContainer>
      <DemoSideMenu />
      <DemoContent id="main">
        <DemoUserInformationHeader />
        <Switch>
          <Route
            exact={true}
            path="/projectPlan/:code"
            component={ProjectPlan}
          />
          <Route
            exact={true}
            path="/gantt/:code"
            component={ProjectPlanGantt}
          />
          <Route exact={true} path="/kanban/:code" component={ProjectKanban} />
          <Route exact={true} path="/myTasks" component={MyTasks} />
          <Route
            exact={true}
            path="/burndownChart/:code"
            component={BurndownChart}
          />
          <Route
            exact={true}
            path="/versionReport/:code"
            component={ProjectVersionReport}
          />
          <Redirect to="/projectPlan/demo" />
        </Switch>
      </DemoContent>
    </RootContainer>
  )
}
